module.exports = __webpack_public_path__ + "img/kymalogo.4556c38a.svg";